import { Persona, PersonaPresence, PersonaSize } from '@fluentui/react';
import { makeAutoObservable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import API, { ICurrentUserInfo } from '../../API';
import { IUserConfigPackage } from '../../API';
import { MSALConfigGen } from '../../authConfig';

export interface ICurrentUserAccountProps {
	state: CurrentUserAccountState;
}

export class CurrentUserAccountState {
	userConfig: IUserConfigPackage;

	async load() {
		this.isLoading = true;
		let token = await this.userConfig.getToken();
		let api = new API(token);
		this.userAccountInfo = await api.getCurrentUserInfo();
		this.setLoading(false);
		this.setUserAccountInfo(this.userAccountInfo);
	}

	setLoading(isLoading: boolean) {
		this.isLoading = isLoading;
	}

	setUserAccountInfo(userAccountInfo: ICurrentUserInfo) {
		this.userAccountInfo = userAccountInfo;
	}
	
	public userAccountInfo?: ICurrentUserInfo;
	public isLoading: boolean = false;

	public constructor(iuserconfigPackage: IUserConfigPackage) {
		this.userConfig = iuserconfigPackage;
		makeAutoObservable(this);
	}
}

class CurrentUserAccount extends React.Component<ICurrentUserAccountProps> {

	componentDidMount(): void {
		if (this.props.state.userAccountInfo === undefined && !this.props.state.isLoading) {
			this.props.state.load();
		}
	}

	render() {

		if (this.props.state.isLoading || this.props.state.userAccountInfo === undefined) {
			return <></>;
		}

		let currentTenant = this.props.state.userAccountInfo?.memberTenants.find(t => t.id === this.props.state.userAccountInfo?.currentTenantId);

		//Get the stored tenant info
		let storedTenants = MSALConfigGen.getStoredTenants();
		let storedTenant = storedTenants.find(t => t.id === this.props.state.userAccountInfo?.currentTenantId);
		if(storedTenant && currentTenant) {
			currentTenant.domain = storedTenant.domain;
		}

		return (
			<div title={this.props.state.userAccountInfo?.name + ' (' + currentTenant?.domain + '/' + currentTenant?.id + ')'}>
				 <Persona
					text={this.props.state.userAccountInfo?.name}
					secondaryText={currentTenant?.domain}
					imageUrl={this.props.state.userAccountInfo?.photoUrl}
					size={PersonaSize.size32}
					presence={PersonaPresence.none}
					hidePersonaDetails={false}
					imageAlt={this.props.state.userAccountInfo?.name}
					styles={{
						primaryText: { color: 'white' },
						secondaryText: { color: 'white' },
					}}
				/>
			</div>
		);
	}
}

export default observer(CurrentUserAccount);
